/** @format */

import { Component, Input, OnInit } from '@angular/core';
import { UtilityService, TaggingService } from '@shared/utils/services';
import { Accordion } from './accordion.model';

@Component({
    selector: 'home-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: false
})
export class AccordionComponent implements OnInit {
	@Input() addlData: any;
	@Input() pageType: string;
	@Input() tagSectionNum: string;
	@Input() widgetTypeTag = 'accordion';
	@Input() data: any;
	accordionData: any[];

	public altTagService: any;
	public targetService: any;

	constructor(
		private taggingService: TaggingService,
		private utilityService: UtilityService
	) {
		this.altTagService = taggingService.altTag;
		this.targetService = this.utilityService.target;
	}

	ngOnInit() {
		if (this.data) {
			this.accordionData = [];
			this.makeBlock();
		}
	}

	makeBlock() {
		for (const accordion of this.data) {
			let hasAccordionSection;

			if (accordion.accordionSection && accordion.accordionSection.length !== 0) {
				hasAccordionSection = !this.utilityService.isObjectInArrayEmpty(
					accordion.accordionSection
				);

				for (const element of accordion.accordionSection) {
					element.answer = decodeURIComponent(element.answer);
				}
			} else {
				hasAccordionSection = false;
			}

			if (accordion.answer && accordion.answer != null) {
				this.accordionData.push(
					new Accordion(
						accordion.question,
						hasAccordionSection,
						decodeURIComponent(accordion.answer),
						accordion.cta,
						accordion.accordionSection
					)
				);
			} else {
				this.accordionData.push(
					new Accordion(
						accordion.question,
						hasAccordionSection,
						accordion.answer,
						accordion.cta,
						accordion.accordionSection
					)
				);
			}
		}
	}

	createTag(parentIndex: number, ctaIndex: number, ctaText: string, altText: string) {
		return this.taggingService.createTag(
			this.tagSectionNum,
			this.widgetTypeTag,
			parentIndex,
			ctaIndex,
			ctaText,
			altText
		);
	}
}
